export default function EmptyState({ icon = "✨", title = "Nothing here", text = "No records found." }) {
  return (
    <section className="empty-state">
      <div className="empty-icon">{icon}</div>
      <h3>{title}</h3>
      <p>{text}</p>
    </section>
  );
}
